import Web3 from "web3";
import { CHAINS, PROJECT_ID, BUYCONTRACTABI } from "../config/env";
import toast from "react-hot-toast";
import { EthereumProvider } from "@walletconnect/ethereum-provider";
import { RPC_LISTS } from "../config/env";
import { ERC20_ABI } from "../config/erc20";
import { ROUTER_ABI } from "../config/Router";
import { ethers } from "ethers";
import { getWalletAddress } from "../lib/localStorage";

let defaultWeb3 = null;

export const UseWeb3 = (error = false, chainId) => {
  console.log(chainId, "chainIdchainId", !error && defaultWeb3)
  if (!error && defaultWeb3) return defaultWeb3;
  console.log(RPC_LISTS[chainId], "RPC_LISTS[chainId][0]");
  const httpProvider = new Web3.providers.HttpProvider(RPC_LISTS[chainId][0]);
  const web3 = new Web3(httpProvider);
  // defaultWeb3 = web3;
  return web3;
};


export const useWeb3 = async () => {

  const RPC_URL = CURRENT_RPC_URL();
  const CHAIN_ID = CURRENT_CHAIN_ID();
  const httpProvider = new Web3.providers.HttpProvider(RPC_URL)

  let web3;


  if (localStorage.getItem("walletConnect") != null) {
    console.log(localStorage.getItem("walletConnect"), "sessionStorage.getItem")
    // alert("wallet connect call")
    const provider = await EthereumProvider.init({
      projectId: PROJECT_ID, // required
      chains: [CHAIN_ID], // required
      showQrModal: true // requires @walletconnect/modal
    })
    await provider.enable()
    web3 = new Web3(provider);

  }
  else if (typeof window.BinanceChain !== 'undefined') {
    console.log(typeof window.BinanceChain, "sessionStorage.getItem")
    web3 = new Web3(window.BinanceChain);
    // return web3;
  }

  else if (localStorage.getItem("adminWalletAddress") != null) {
    console.log(localStorage.getItem("adminWalletAddress"), "localStorage.getItem")
    web3 = new Web3(window.ethereum);
    //   return web3;
  } else {
    console.log(localStorage.getItem("adminWalletAddress"), "localStorage.getItem")
    web3 = new Web3(httpProvider);
    //   return web3;
  }
  const chainIds = await web3.eth.getChainId();
  if (parseInt(chainIds) != parseInt(CHAIN_ID)) {
    const data = await SwitchChain();
    if (data) {
      window.location.reload();
    }
  }

  return web3;

}



export const usehttpProvider = async () => {
  const RPC_URL = CURRENT_RPC_URL();
  const CHAIN_ID = CURRENT_CHAIN_ID();
  console.log("RPC_URLRPC_URL", RPC_URL);
  const httpProvider = new Web3.providers.HttpProvider(RPC_URL);

  let web3;

  web3 = new Web3(httpProvider);

  const chainIds = await web3.eth.getChainId();
  console.log("chainIds_chainIds_V", chainIds);
  if (parseInt(chainIds) != parseInt(CHAIN_ID)) {
    const data = await SwitchChain();
    if (data) {
      window.location.reload();
    }
  }

  return web3;
};

export const UseProvider = async () => {
  const CHAIN_ID = CURRENT_CHAIN_ID();

  if (localStorage.getItem("wcv2") != null) {
    const provider = await EthereumProvider.init({
      projectId: PROJECT_ID, // required
      chains: [CHAIN_ID], // required
      showQrModal: true, // requires @walletconnect/modal
    });
    await provider.enable();

    return provider;
  } else if (typeof window.BinanceChain !== "undefined") {
    return window.BinanceChain;
  } else if (sessionStorage.getItem("accountInfo") != null) {
    return window.ethereum;
  }
};

export const CURRENT_RPC_URL = () => {
  const index = GetChainIndex();
  console.log("====================================");
  console.log("CURRENT_RPC_URL", index);
  console.log("====================================");
  return CHAINS[index].RPC_URL;
};

export const GetChainIndex = () => {
  return localStorage.getItem("CHAIN") ? localStorage.getItem("CHAIN") : "0";
};

export const CURRENT_CHAIN_ID = () => {
  const index = GetChainIndex();
  console.log("index>>>>", index);
  return CHAINS[index].CHAIN_ID;
};

export const SwitchChain = async () => {
  const RPC_URL = CURRENT_RPC_URL();
  const CHAIN_ID = CURRENT_CHAIN_ID();
  // Check if MetaMask is installed
  // MetaMask injects the global API into window.ethereum
  const hexString = CHAIN_ID.toString(16);
  if (window.ethereum) {
    try {
      // check if the chain to connect to is installed

      const data = window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x" + hexString }], // chainId must be in hexadecimal numbers
      });
      await toast.promise(
        data,
        {
          loading: "Switching Network ...",
          success: "Network Switched Successfully",
          error: "Error ! When Switching Network",
        },
        {
          style: {
            minWidth: "300px",
            minHeight: "55px",
          },
        },
        await sleep(1000)
      );
      return true;
    } catch (error) {
      // This error code indicates that the chain has not been added to MetaMask
      // if it is not, then install it into the user MetaMask
      if (error.code === 4902) {
        try {
          const data = window.ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: "0x" + hexString,
                rpcUrl: RPC_URL,
              },
            ],
          });
          await toast.promise(
            data,
            {
              loading: "Switching Network ...",
              success: "Network Switched Successfully",
              error: "Error ! When Switching Network",
            },
            {
              style: {
                minWidth: "300px",
                minHeight: "55px",
              },
            }
          );
          return true;
        } catch (addError) {
          console.error(addError);
          toast.error(`Error : ${addError}`, {
            style: {
              minWidth: "300px",
              minHeight: "55px",
            },
          });
        }
      }
      console.error(error);
    }
  } else {
    // if no window.ethereum then MetaMask is not installed

    return false;
  }
};

export const SwitchChainS = async (i) => {
  const RPC_URL = CHAINS[i].RPC_URL;
  const CHAIN_ID = CHAINS[i].CHAIN_ID;
  // Check if MetaMask is installed
  // MetaMask injects the global API into window.ethereum
  const hexString = CHAIN_ID.toString(16);
  if (window.ethereum) {
    try {
      // check if the chain to connect to is installed

      const data = window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x" + hexString }], // chainId must be in hexadecimal numbers
      });
      console.log("Switching_Network3");
      await toast.promise(
        data,
        {
          loading: "Switching Network ...",
          success: "Network Switched Successfully",
          error: "Error ! When Switching Network",
        },
        {
          style: {
            minWidth: "300px",
            minHeight: "55px",
          },
        }
        // await sleep(1000)
      );
      return true;
    } catch (error) {
      console.log("errrrrrrrror", error);
      // This error code indicates that the chain has not been added to MetaMask
      // if it is not, then install it into the user MetaMask
      if (error.code === 4902) {
        try {
          const data = window.ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: "0x" + hexString,
                rpcUrl: RPC_URL,
              },
            ],
          });
          console.log("Switching_Network4");
          await toast.promise(
            data,
            {
              loading: "Switching Network ...",
              success: "Network Switched Successfully",
              error: "Error ! When Switching Network",
            },
            {
              style: {
                minWidth: "300px",
                minHeight: "55px",
              },
            }
          );
          return true;
        } catch (addError) {
          console.error(addError);
          toast.error(`Error : ${addError}`, {
            style: {
              minWidth: "300px",
              minHeight: "55px",
            },
          });
        }
      }
      console.error(error);
    }
  } else {
    // if no window.ethereum then MetaMask is not installed

    return false;
  }
};

export const setChainId = async (i) => {
  try {
    localStorage.setItem("CHAIN", i);
  } catch (err) {
    console.log("setChainId_err", err);
  }
};

export const sleep = (ms) => {

  new Promise(resolve => setTimeout(resolve, ms))
}

export const CheckFactory = async (router, chainId) => {
  console.log("🚀 ~ CheckFactory ~ router, chainId:", router, chainId);
  try {
    // const web3 = await UseWeb3(false, chainId);
    const provider = new ethers.JsonRpcProvider(RPC_LISTS[chainId][0]);
    const router0 = new ethers.Contract(router, ROUTER_ABI, provider);
    // const router = new web3.eth.Contract(router, ROUTER_ABI);
    const factory0address = await router0.factory();
    console.log("🚀 ~ CheckFactory ~ factory0address:", factory0address);
    return {
      status: true,
      data: factory0address,
    };
  } catch (err) {
    console.log("🚀 ~ CheckFactory ~ err:", err);
    return {
      status: false,
      data: {},
    };
  }
};

export const UseToken = async (chainId, address) => {
  console.log("🚀 ~ UseToken ~ chainId, address:", chainId, address)
  try {
    let details = {};
    const web3 = await useWeb3();
    const checkIsValid = web3.utils.isAddress(address);
    if (checkIsValid) {
      const token = await UseERC20(address, chainId);
      details.tokenName = await token.methods.name().call();
      details.tokenSymbol = await token.methods.symbol().call();
      details.tokenDecimal = await token.methods.decimals().call();
      console.log("useToken_tokenDetails_data", details);
      return {
        status: true,
        data: details,
      };
    } else {
      return {
        status: false,
        data: {},
      };
    }
  } catch (e) {
    console.log("useToken_err", e);
    return {
      status: false,
      data: {},
    };
  }
};

export const UseERC20 = async (Token, chainId) => {
  const web3 = await useWeb3();
  const contract = new web3.eth.Contract(ERC20_ABI, Token);
  return contract;
};

export const UseBuyContract = async () => {
  try {
    const web3 = await useWeb3();
    const index = GetChainIndex();
    const BUYCONTRACTADDRESS = CHAINS[index].BUYCONTRACTADDRESS
    const contract = new web3.eth.Contract(BUYCONTRACTABI, BUYCONTRACTADDRESS);
    return contract;
  } catch (e) {
    console.log(e, "UseBuyContract")
  }
}

export const AddNewPlan = async (data) => {
  console.log("🚀 ~ AddNewPlan ~ data:", data)
  try {
    const web3 = await useWeb3();
    const contract = await UseBuyContract();
    const account = getWalletAddress();

    const Transcation = {
      subId: data.subId.toString(),
      name: data.name,
      feeAmount: data.feeAmount,
      flashloanLimit: data.flashloanLimit,
      validity: data.validity,
      profitMax: data.profitMax,
      acceptedToken: data.acceptedToken,
      percent: data.percent
    };
    // var gasprice = await web3.eth.getGasPrice();
    // var gaslimit = await encoded.estimateGas(Transcation)
    // var gasLimit = web3.utils.toHex(gaslimit);
    // var gasPrice = web3.utils.toHex(gasprice);

    var gaslimit = parseInt(220000)
    var gasprice = await web3.eth.getGasPrice();


    let chainId = CURRENT_CHAIN_ID()

    if (chainId == 97) {
      const Rsepone = await contract.methods.addPlan(
        data.subId.toString(),
        data.name,
        data.feeAmount,
        // data.flashloanLimit,
        data.validity,
        data.profitMax,
        data.acceptedToken,
        data.percent)
        .send({ from: web3.utils.toChecksumAddress(account) })
      return Rsepone
    }
    else {
      const Rsepone = await contract.methods.addPlan(
        data.subId.toString(),
        data.name,
        data.flashloanLimit,
        data.feeAmount,
        // data.validity,
        data.profitMax,
        web3.utils.toChecksumAddress(data.acceptedToken),
        data.percent)
        .send({ from: web3.utils.toChecksumAddress(account), gasLimit: gaslimit, gasPrice: gasprice })
      return Rsepone
    }



  }
  catch (e) {
    console.log(e, "AddNewPlan")
  }

}

export const getOwnerAddress = async () => {
  try {
    let contract = await UseBuyContract()
    let owenr = await contract.methods.owner().call()
    return owenr
  }
  catch (err) {
    console.log(err, "ERR")
  }
}

export const GetBuyTokenAddress = async () => {
  try {
    const web3 = await useWeb3();
    const index = GetChainIndex();
    const BUYTOKENADDRESS = CHAINS[index].BUYTOKENADDRESS
    console.log("🚀 ~ GetBuyTokenAddress ~ BUYTOKENADDRESS:", BUYTOKENADDRESS)
    return BUYTOKENADDRESS;
  }
  catch (err) {
    console.log(err, "ERR")
  }
}

export const toFixedNumber = (x) => {
  if (Math.abs(x) < 1.0) {
    var e = parseInt(x.toString().split('e-')[1]);
    if (e) {
      x *= Math.pow(10, e - 1);
      x = '0.' + (new Array(e)).join('0') + x.toString().substring(2);
    }
  } else {
    var e = parseInt(x.toString().split('+')[1]);
    if (e > 20) {
      e -= 20;
      x /= Math.pow(10, e);
      x += (new Array(e + 1)).join('0');
    }
  }
  return x;
}



